import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/twilio`;

export const fetchTwilioDetails = async (accountId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/account/${accountId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchUserTwilioDetails = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};

export const createTwilio = async (config) => {
  const res = await axiosInstance.post(BASE_URL, config, getAuthHeaders());
  return res.data;
};

export const updateTwilioDetails = async (uuid, config) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/${uuid}`,
    config,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteTwilioDetails = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const startTwilioCall = async ({ phoneId, receivingNumber }) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/start-call/${phoneId}`,
    { receivingNumber },
    getAuthHeaders(),
  );
  return res.data;
};

export const connectTwilioIncoming = async () => {
  const res = await axiosInstance.post(
    `${BASE_URL}/incoming`,
    {},
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchTwilioPhoneNumbers = async (config) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/all`,
    config,
    getAuthHeaders(),
  );
  return res.data;
};

export const validateTwilioCredentials = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/validate-credentials`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};
